<template>
    <div class="sso-bg" :style="{'height': documentClientHeight}">
        
    </div>
</template>

<script>
import vueCookie from 'vue-cookies'
export default {
    data () {
        documentClientHeight: '400px'
    },
    
    created () {
        this.documentClientHeight = document.documentElement['clientHeight'] + 'px'
        window.onresize = () => {
            this.documentClientHeight = document.documentElement['clientHeight'] + 'px'
        }
        let query = this.$route.query || {}
        if (query.token) {
        vueCookie.set('token', query.token, {
            domain: process.env.VUE_APP_DOADMIN
        });
        
        this.$get("/oms/businessWorkbench/getUserInfo").then(({data}) => {
            if (data && data.code == 'C0000') {
                this.$utils.setSessionStorage('userInfo', data.result)
                this.$router.push({
                    name: "home",
                    replace: true,
                });
                setTimeout(() => {
                    window.location.reload(true)
                }, 500)
            }
        })
        return false
        }
    }
}
</script>

<style lang="scss">
.sso-bg {
    background-image: url(@/assets/img/bg1.jpg);
    width: 100%;
    height:100%;
    background-repeat: no-repeat,no-repeat;
    background-position: top,bottom;
}
</style>